/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAppDynamics extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAppDynamics");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAppDynamics.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAppDynamics>): ServiceAccountNativeDetailsForAppDynamics {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAppDynamics(), model);
        ServiceAccountNativeDetailsForAppDynamics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAppDynamics>): ServiceAccountNativeDetailsForAppDynamics {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAppDynamics.newInstance(<ServiceAccountNativeDetailsForAppDynamics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAppDynamics) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAppDynamics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAppDynamics): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAppDynamics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
